import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, useLocation, useNavigate } from 'react-router';

import { ALL_EXISTING_ROUTES, PAGE_TO_ROUTE_TAGS_MAPPER } from '../../../constants/routePath';
import { QUERY_SELECTED_CHIP_KEY } from '@/modules/common/constants/queryParams';

import { processHistoryObject } from '../../../helpers/history';
import * as commonSelectors from '../../../redux/selectors/common';
import { parseQueryObject } from '@/modules/Search/helpers/query';

export const useVerifyChipInUrl = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tagPages = useSelector(commonSelectors.tagPagesSelector);

  const query = parseQueryObject(location.search) as { [QUERY_SELECTED_CHIP_KEY]?: string };
  const queryChip = query[QUERY_SELECTED_CHIP_KEY];

  const currentRoute = ALL_EXISTING_ROUTES.find((route$) => matchPath(route$, location.pathname)) ?? '';

  const isChipsAvailable = tagPages.some((page) => PAGE_TO_ROUTE_TAGS_MAPPER[page].includes(currentRoute));

  useLayoutEffect(() => {
    if (queryChip && !isChipsAvailable) {
      navigate(
        processHistoryObject({
          search: {
            ...parseQueryObject(location.search),
            [QUERY_SELECTED_CHIP_KEY]: '',
          },
        }),
        { replace: true },
      );
    }
  }, [currentRoute, isChipsAvailable]);
};
